// extracted by mini-css-extract-plugin
export var wrapper = "tags-module--wrapper--2gYT0";
export var tags__list = "tags-module--tags__list--14Mpb";
export var tags = "tags-module--tags--3qzd7";
export var tags__items = "tags-module--tags__items--29tPy";